<template>
  <div class="portal-reviews-filter__content" v-click-outside="hide">
    <slot :close="close" :show="show"></slot>

    <search-input
      v-show="!close"
      v-model="filterValue"
      v-on:close="hide"
      ref="search"
    ></search-input>

    <traits-list
      :traits="filteredTraits"
      :summaryFilteredUrl="summaryFilteredUrl"
      v-if="!close"
      v-on:click="handleTraitClick"
    ></traits-list>
  </div>
</template>

<script>
import SearchInput from './search_input';
import Traitlist from './traits_list';
import {
  getFilteredTraits,
  getSummaryFilteredUrl,
  getProcessedTraitList,
} from './utils';
import vClickOutside from 'v-click-outside';

export default {
  name: 'portal-reviews-filter',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    'search-input': SearchInput,
    'traits-list': Traitlist,
  },

  props: {
    initialTraits: String, // json
    urlPattern: String,
    urlReplace: String,
    url: String,
  },

  data: function () {
    return {
      close: true,
      filterValue: '',
      traits: JSON.parse(this.initialTraits),
    };
  },

  computed: {
    filteredTraits: function () {
      return getFilteredTraits(this.traits, this.filterValue);
    },
    summaryFilteredUrl: function () {
      return getSummaryFilteredUrl(
        this.traits,
        this.urlPattern,
        this.urlReplace,
        this.url
      );
    },
  },

  methods: {
    show: function () {
      this.close = false;
      setTimeout(() => {
        this.$refs.search.$el.querySelector('input').focus();
      }, 0);
    },
    hide: function () {
      this.close = true;
      this.traits = getProcessedTraitList(this.traits);
    },
    handleTraitClick: function (id) {
      this.traits = getProcessedTraitList(this.traits, id);
    },
  },
};
</script>

<style lang="scss">
.portal-reviews-filter__content {
  position: relative;
}
</style>
